module.exports = __webpack_public_path__ + "static/media/balloon.fb70a38c.png";